import React from "react";
import { styled } from "styled-components";
import { Menu, MyCart } from "../../assets/icons";
import { Colors } from "../../ColorConstants";
import Button from "../Buttons";

const MobileButtonContainer = ({
  showCart,
  onClickButton1,
  onClickButton2,
  cartNumber,
}) => {
  return (
    <StyledButtonContainer showCart={showCart}>
      <ButtonWrapper>
        {showCart ? (
          <CartContainer>
            <Button
              variant="filled"
              backgroundColor={`rgba(0, 0, 0, 0.6)`}
              size="large"
              fontColor={Colors.white}
              padding={"0.5rem 0.5rem"}
              cursorType="pointer"
              onClick={onClickButton1}
              startIcon={<MyCartImageMobile src={MyCart} marginRight="0rem" />}
            />
            <CartNumberContainer>
              <CartNumberText>{cartNumber}</CartNumberText>
            </CartNumberContainer>
          </CartContainer>
        ) : null}
        <Button
          variant="none"
          backgroundColor="transparent"
          padding={"0rem 0.1rem"}
          endIcon={<MyCartImageMobile src={Menu} marginRight="0" />}
          onClick={onClickButton2}
        />
      </ButtonWrapper>
    </StyledButtonContainer>
  );
};

const StyledButtonContainer = styled.div`
  @media only screen and (min-width: 500px) {
    display: none;
  }
  @media (max-width: 500px) {
    position: absolute;
    top: 0;
    right: 0;
    margin-inline-end: 1rem;
    margin-top: ${(props) => (props.showCart ? "0.4rem" : "0.8rem")};
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: ${(props) => (props.showCart ? "center" : "flex-end")};
  gap: 1rem;
`;

const CartContainer = styled.div`
  display: flex;
  position: relative;
`;
const MyCartImageMobile = styled.img`
  width: 1.5rem;
  height: 1.3rem;
  margin-right: ${(props) => props.marginRight};
`;
const CartNumberContainer = styled.div`
  display: flex;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 0.5rem;
  padding: 0.1rem;
  background-color: ${Colors.maroonRed};
  position: absolute;
  top: 0.3rem;
  right: 0.2rem;
  justify-content: center;
`;
const CartNumberText = styled.span`
  color: ${Colors.white};
  text-align: center;
  font-size: 0.5rem;
  font-weight: 600;
  line-height: 0.5rem;
`;

export default MobileButtonContainer;
